module.exports = __webpack_public_path__ + "i18n/ru_60c26399af5ad53f2bf6e5597b582d95.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ru.json
// module id = 2MCb
// module chunks = 154